// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* base styles */
._GzYRV {
  line-height: 1.2;
  white-space: pre-wrap;
  white-space: -moz-pre-wrap;
  white-space: -pre-wrap;
  white-space: -o-pre-wrap;
  word-wrap: break-word;
}
._3eOF8 {
  margin-right: 5px;
  font-weight: bold;
}
._3eOF8 + ._3eOF8 {
  margin-left: -5px;
}
._1MFti {
  cursor: pointer;
}
._f10Tu {
  font-size: 1.2em;
  margin-right: 5px;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
}
._1UmXx::after {
  content: '\\25B8';
}
._1LId0::after {
  content: '\\25BE';
}
._1pNG9 {
  margin-right: 5px;
}
._1pNG9::after {
  content: '...';
  font-size: 0.8em;
}
._2IvMF {
  background: #eee;
}
._2bkNM {
  margin: 0 10px;
  padding: 0;
}
/* default light style */
._1MGIk {
  font-weight: 600;
  margin-right: 5px;
  color: #000000;
}
._3uHL6 {
  color: #000000;
}
._2T6PJ {
  color: #df113a;
}
._1Gho6 {
  color: #df113a;
}
._vGjyY {
  color: #2a3f3c;
}
._1bQdo {
  color: #0b75f5;
}
._3zQKs {
  color: #469038;
}
._1xvuR {
  color: #43413d;
}
._oLqym {
  color: #000000;
}
._2AXVT {
  color: #000000;
}
._2KJWg {
  color: #000000;
}
/* default dark style */
._11RoI {
  background: #002b36;
}
._17H2C {
  color: #fdf6e3;
}
._3QHg2 {
  color: #fdf6e3;
}
._3fDAz {
  color: #fdf6e3;
}
._2bSDX {
  font-weight: bolder;
  margin-right: 5px;
  color: #fdf6e3;
}
._gsbQL {
  color: #fdf6e3;
}
._LaAZe {
  color: #81b5ac;
}
._GTKgm {
  color: #81b5ac;
}
._Chy1W {
  color: #cb4b16;
}
._2bveF {
  color: #d33682;
}
._2vRm- {
  color: #ae81ff;
}
._1prJR {
  color: #268bd2;
}
`, "",{"version":3,"sources":["webpack://./node_modules/react-json-view-lite/dist/index.css"],"names":[],"mappings":"AAAA,gBAAgB;AAEhB;EACE,gBAAA;EACA,qBAAA;EACA,0BAAA;EACA,sBAAA;EACA,wBAAA;EACA,qBAAA;AAAF;AAGA;EACE,iBAAA;EACA,iBAAA;AADF;AAIA;EACE,iBAAA;AAFF;AAKA;EACE,eAAA;AAHF;AAMA;EACE,gBAAA;EACA,iBAAA;EACA,yBAAA;EACG,sBAAA;EACK,iBAAA;AAJV;AAOA;EACE,gBAAA;AALF;AAQA;EACE,gBAAA;AANF;AASA;EACE,iBAAA;AAPF;AAUA;EACE,cAAA;EACA,gBAAA;AARF;AAWA;EACE,gBAAA;AATF;AAYA;EACE,cAAA;EACA,UAAA;AAVF;AACA,wBAAwB;AAaxB;EACE,gBAAA;EACA,iBAAA;EACA,cAAA;AAXF;AAiBA;EACE,cAAA;AAfF;AAkBA;EACE,cAAA;AAhBF;AAmBA;EACE,cAAA;AAjBF;AAoBA;EACE,cAAA;AAlBF;AAqBA;EACE,cAAA;AAnBF;AAsBA;EACE,cAAA;AApBF;AAuBA;EACE,cAAA;AArBF;AAwBA;EACE,cAAA;AAtBF;AAyBA;EACE,cAAA;AAvBF;AA0BA;EACE,cAAA;AAxBF;AACA,uBAAuB;AA2BvB;EACE,mBAAA;AAzBF;AA4BA;EACE,cAAA;AA1BF;AA6BA;EACE,cAAA;AA3BF;AA8BA;EACE,cAAA;AA5BF;AA+BA;EACE,mBAAA;EACA,iBAAA;EACA,cAAA;AA7BF;AAmCA;EACE,cAAA;AAjCF;AAoCA;EACE,cAAA;AAlCF;AAqCA;EACE,cAAA;AAnCF;AAsCA;EACE,cAAA;AApCF;AAuCA;EACE,cAAA;AArCF;AAwCA;EACE,cAAA;AAtCF;AAyCA;EACE,cAAA;AAvCF","sourcesContent":["/* base styles */\n\n._GzYRV {\n  line-height: 1.2;\n  white-space: pre-wrap;\n  white-space: -moz-pre-wrap;\n  white-space: -pre-wrap;\n  white-space: -o-pre-wrap;\n  word-wrap: break-word;\n}\n\n._3eOF8 {\n  margin-right: 5px;\n  font-weight: bold;\n}\n\n._3eOF8 + ._3eOF8 {\n  margin-left: -5px;\n}\n\n._1MFti {\n  cursor: pointer;\n}\n\n._f10Tu {\n  font-size: 1.2em;\n  margin-right: 5px;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n          user-select: none;\n}\n\n._1UmXx::after {\n  content: '\\25B8';\n}\n\n._1LId0::after {\n  content: '\\25BE';\n}\n\n._1pNG9 {\n  margin-right: 5px;\n}\n\n._1pNG9::after {\n  content: '...';\n  font-size: 0.8em;\n}\n\n._2IvMF {\n  background: #eee;\n}\n\n._2bkNM {\n  margin: 0 10px;\n  padding: 0;\n}\n\n/* default light style */\n._1MGIk {\n  font-weight: 600;\n  margin-right: 5px;\n  color: #000000;\n}\n\n._2YKJg {\n}\n\n._3uHL6 {\n  color: #000000;\n}\n\n._2T6PJ {\n  color: #df113a;\n}\n\n._1Gho6 {\n  color: #df113a;\n}\n\n._vGjyY {\n  color: rgb(42, 63, 60);\n}\n\n._1bQdo {\n  color: #0b75f5;\n}\n\n._3zQKs {\n  color: rgb(70, 144, 56);\n}\n\n._1xvuR {\n  color: #43413d;\n}\n\n._oLqym {\n  color: #000000;\n}\n\n._2AXVT {\n  color: #000000;\n}\n\n._2KJWg {\n  color: #000000;\n}\n\n/* default dark style */\n._11RoI {\n  background: rgb(0, 43, 54);\n}\n\n._17H2C {\n  color: rgb(253, 246, 227);\n}\n\n._3QHg2 {\n  color: rgb(253, 246, 227);\n}\n\n._3fDAz {\n  color: rgb(253, 246, 227);\n}\n\n._2bSDX {\n  font-weight: bolder;\n  margin-right: 5px;\n  color: rgb(253, 246, 227);\n}\n\n._1RQEj {\n}\n\n._gsbQL {\n  color: rgb(253, 246, 227);\n}\n\n._LaAZe {\n  color: rgb(129, 181, 172);\n}\n\n._GTKgm {\n  color: rgb(129, 181, 172);\n}\n\n._Chy1W {\n  color: rgb(203, 75, 22);\n}\n\n._2bveF {\n  color: rgb(211, 54, 130);\n}\n\n._2vRm- {\n  color: rgb(174, 129, 255);\n}\n\n._1prJR {\n  color: rgb(38, 139, 210);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
